import { useQuery } from "react-query";
import { getEODPayment, getTransactions } from "../../../services/transaction";

export const useGetTransactions = ({ queries = "", isEnabled = true }) => {
  return useQuery(
    ["getTransactions", queries],
    () => getTransactions(queries).then((res) => res?.data),
    {
      enabled: queries === "" && !isEnabled ? false : true,
      refetchInterval: 5000,
      staleTime: 5000,
    },
  );
};

export const useGetPaymentEODTransactions = (data) => {
  return useQuery(
    ["getTransactions", data],
    () => getEODPayment(data).then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: false,
    },
  );
};
